<script>

export default {
  name: 'App',
}

</script>

<template>
  <router-view></router-view>
  <dynamic-sidebar></dynamic-sidebar>
</template>